export default ["ADDED"  ,"PAID"  ,"IN_DEBT"  ,"DEBT_PAID"  ,"DEBT_FAILED"  ,"confirmed_manually"]

